import React from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import CustomDialog from '../Dialogs/CustomDialog';
import ReCaptcha from '../ReCaptcha';

const ForgetPassword = ({ open, forgetPassword, getPassword,
  tel, handleChange, reCaptchaRef }) =>
  <CustomDialog
    open={open}
    disableBackdropClick
    disableEscapeKeyDown
    name="Mot de passe oublié"
    subTitle={'Merci d\'entrer votre numéro de téléphone'}
    actions={[
      <Button key={0} onClick={forgetPassword}
        style={{ fontSize: 'large' }} color="primary">
        Valider
      </Button>,
      <Button key={1} onClick={getPassword} color="primary">
        Retour
      </Button>
    ]}
    actionStyle={{
      justifyContent: 'center',
      flexDirection: 'column'
    }}
  >
    <TextField
      onChange={handleChange('tel')}
      autoFocus
      margin="dense"
      id="tel"
      label={'Numéro de téléphone'}
      type="text"
      value={tel}
      inputProps={{
        style: { textAlign: 'center' }
      }}
      required
      fullWidth
    />
    <ReCaptcha ref={reCaptchaRef} />
  </CustomDialog>;

export default ForgetPassword;
